/**
 * Partial / unknown-outcome network failure (design_handoff §1g #6),
 * distinct from a clean server rejection (§1g #3): the request may or may
 * not have committed, so — unlike reads — it is never auto-retried, since
 * the API has no idempotency key to make a resend safe.
 */
export function PartialFailureNotice({ onCheckCurrentState }: { onCheckCurrentState: () => void }) {
  return (
    <div className="partial-failure-notice" role="alert">
      <strong>Outcome unknown</strong>
      <p>
        The network request failed before a response arrived. The server may or may not have committed this change.
        It was not retried automatically, because resending it safely would require an idempotency key the API
        does not currently expose.
      </p>
      <div className="error-actions">
        <button type="button" onClick={onCheckCurrentState}>
          Check current state
        </button>
        <button type="button" disabled title="Your draft is preserved in this form">
          Keep draft and wait
        </button>
      </div>
    </div>
  );
}
